import { call, put, all, takeEvery } from 'redux-saga/effects'

import {
  GET_CHOICES_GEOLOCATIONS,
  getChoicesGeolocationsSuccess,
  getChoicesGeolocationsFailure,
  GET_CHOICES_COUNTRIES,
  getChoicesCountriesSuccess,
  getChoicesCountriesFailure,
  GET_CHOICES_INTERESTS,
  getChoicesInterestsSuccess,
  getChoicesInterestsFailure,
  GET_CHOICES_LANGUAGES,
  getChoicesLanguagesSuccess,
  getChoicesLanguagesFailure,
  GET_CHOICES_PIXELS,
  getChoicesPixelsSuccess,
  getChoicesPixelsFailure,
  GET_CHOICES_CTA,
  getChoicesCTASuccess,
  getChoicesCTAFailure,
  GET_CHOICES_ACTIONS,
  getChoicesActionsSuccess,
  getChoicesActionsFailure,
  GET_CHOICES_ALLOCATION_UNITS,
  getChoicesAllocationUnitsSuccess,
  getChoicesAllocationUnitsFailure,
  GET_FACEBOOK_CLIENT_APPS,
  getFacebookClientAppsSuccess,
  getFacebookClientAppsFailure,
  GET_CHOICES_CTA_BY_GOAL,
  getChoicesCTAByGoalSuccess,
  getChoicesCTAByGoalFailure,
  GET_CHOICES_BEHAVIOURS,
  getChoicesBehavioursSuccess,
  getChoicesBehavioursFailure,
  GET_CUSTOM_CONVERSIONS,
  getCustomConversionsSuccess,
  getCustomConversionsFailure
} from '../actions/choices'

import {
  getChoicesGeolocationsService,
  getChoicesCountriesService,
  getChoicesInterestsService,
  getChoicesLanguagesService,
  getChoicesActionsService,
  getChoicesCTAService,
  getChoicesPixelsService,
  getChoicesAllocationUnitsService,
  getFacebookClientAppsService,
  getChoicesBehavioursService,
  getCustomConversionsService
} from '../services/choices'

function* choicesWatcher() {
  yield all([
    // PLOP_APPEND_PATTERN_ANCHOR_WATCHER
    takeEvery(GET_CHOICES_GEOLOCATIONS, getChoicesGeolocationsWatcher),
    takeEvery(GET_CHOICES_COUNTRIES, getChoicesCountriesWatcher),
    takeEvery(GET_CHOICES_INTERESTS, getChoicesInterestsWatcher),
    takeEvery(GET_CHOICES_LANGUAGES, getChoicesLanguagesWatcher),
    takeEvery(GET_CHOICES_PIXELS, getChoicesPixelsWatcher),
    takeEvery(GET_CHOICES_ACTIONS, getChoicesActionsWatcher),
    takeEvery(GET_CHOICES_CTA, getChoicesCTAWatcher),
    takeEvery(GET_CHOICES_CTA_BY_GOAL, getChoicesCTAByGoalWatcher),
    takeEvery(GET_CHOICES_ALLOCATION_UNITS, getChoicesAllocationUnitsWatcher),
    takeEvery(GET_FACEBOOK_CLIENT_APPS, getFacebookClientAppsWorker),
    takeEvery(GET_CHOICES_BEHAVIOURS, getChoicesBehavioursWorker),
    takeEvery(GET_CUSTOM_CONVERSIONS, getCustomConversionsWorker)
  ])
}

// PLOP_APPEND_PATTERN_ANCHOR_WORKER

function* getChoicesGeolocationsWatcher({ params }) {
  try {
    const response = yield call(getChoicesGeolocationsService, params)
    yield put(getChoicesGeolocationsSuccess(response))
  } catch (e) {
    yield put(getChoicesGeolocationsFailure(e))
  }
}

function* getChoicesCountriesWatcher() {
  try {
    const response = yield call(getChoicesCountriesService)
    yield put(getChoicesCountriesSuccess(response.results))
  } catch (e) {
    yield put(getChoicesCountriesFailure(e))
  }
}

function* getChoicesInterestsWatcher({ params }) {
  try {
    const response = yield call(getChoicesInterestsService, params)
    yield put(getChoicesInterestsSuccess(response))
  } catch (e) {
    yield put(getChoicesInterestsFailure(e))
  }
}

function* getChoicesLanguagesWatcher({ params }) {
  try {
    const response = yield call(getChoicesLanguagesService, params)
    yield put(getChoicesLanguagesSuccess(response))
  } catch (e) {
    yield put(getChoicesLanguagesFailure(e))
  }
}

function* getChoicesPixelsWatcher({ params, platform }) {
  try {
    const response = yield call(getChoicesPixelsService, params, platform)
    yield put(getChoicesPixelsSuccess(response))
  } catch (e) {
    yield put(getChoicesPixelsFailure(e))
  }
}

function* getChoicesActionsWatcher({ params }) {
  try {
    const response = yield call(getChoicesActionsService, params)
    yield put(getChoicesActionsSuccess(response))
  } catch (e) {
    yield put(getChoicesActionsFailure(e))
  }
}

function* getChoicesCTAWatcher({ params }) {
  try {
    const response = yield call(getChoicesCTAService, params)
    yield put(getChoicesCTASuccess(response))
  } catch (e) {
    yield put(getChoicesCTAFailure(e))
  }
}

function* getChoicesCTAByGoalWatcher({ params }) {
  const goal = params?.goals
  try {
    const response = yield call(getChoicesCTAService, params)
    yield put(getChoicesCTAByGoalSuccess(response, goal))
  } catch (e) {
    yield put(getChoicesCTAByGoalFailure(e))
  }
}

function* getChoicesAllocationUnitsWatcher({ params }) {
  try {
    const response = yield call(getChoicesAllocationUnitsService, params)
    yield put(getChoicesAllocationUnitsSuccess(response))
  } catch (e) {
    yield put(getChoicesAllocationUnitsFailure(e))
  }
}

function* getFacebookClientAppsWorker({ params }) {
  try {
    const response = yield call(getFacebookClientAppsService, params)
    yield put(getFacebookClientAppsSuccess(response))
  } catch (error) {
    yield put(getFacebookClientAppsFailure(error))
  }
}

function* getChoicesBehavioursWorker({ params }) {
  try {
    const response = yield call(getChoicesBehavioursService, params)
    yield put(getChoicesBehavioursSuccess(response))
  } catch (error) {
    yield put(getChoicesBehavioursFailure(error))
  }
}

function* getCustomConversionsWorker({ params }) {
  try {
    const response = yield call(getCustomConversionsService, params)
    yield put(getCustomConversionsSuccess(response))
  } catch (error) {
    yield put(getCustomConversionsFailure(error))
  }
}

export default choicesWatcher
